import { PageHeader } from '@/components/ui';

import { CartaoEmailMonitoramento } from './CartaoEmailMonitoramento';
import { CartaoWhatsApp } from './CartaoWhatsApp';

/**
 * A página do WhatsApp — 06/09/2026, quando `Integrações` deixou de ser uma
 * pilha e cada integração ganhou a sua.
 *
 * ⚠️ O conteúdo é o MESMO cartão de antes, sem uma linha de lógica tocada.
 * **Reorganização de tela não é reorganização de dado** — o que muda é onde a
 * pessoa encontra, não o que o sistema faz.
 */
export function PaginaWhatsApp() {
  return (
    <section className="min-w-0 space-y-6" data-testid="pagina-whatsapp">
      <PageHeader className="mb-0" crumb="Configurações · Integrações" title="WhatsApp e avisos" subtitle="Avisos automáticos e comunicados. Tudo nasce desligado, e o freio para tudo na hora." />
      <CartaoWhatsApp />
      {/* O e-mail do monitoramento mora junto dos avisos (pedido de 10/09). */}
      <CartaoEmailMonitoramento />
    </section>
  );
}
